const ww = $(window).width();

module.exports = ww;
